/*
  Swiper Slider
*/

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const swiperSingle = new Swiper('.swiper', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 14,
  watchOverflow: true,
  loop: true,
  loadPrevNext: true,

  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 1.3,
    },
    // when window width is >= 1080px
    1080: {
      slidesPerView: 1.8,
    },
    // when window width is >= 1920px
    1920: {
      slidesPerView: 2.5,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
